
export default class IndusoftUiStateService {
    private static readonly INDUSOFT_UI_SELECTOR = 'indusoft-ui';

    public get indusoftUI(): HTMLElement & { visible?: boolean; showSwitch?: boolean; } | null {
        return document.querySelector(IndusoftUiStateService.INDUSOFT_UI_SELECTOR);
    }

    public get isVisible(): boolean {
        if (!this.indusoftUI)
            return false;

        return this.indusoftUI.visible ?? false;
    }

    public set isVisible(isVisible: boolean) {
        if (!this.indusoftUI)
            return;

        this.indusoftUI.visible = isVisible;
    }

    public toggleVisible(): void {
        this.isVisible = !this.isVisible;
    }

    public get tooltipSwitchSideBar(): string {
        return this.isVisible ? "Закрыть панель" : "Открыть панель";
    }
}
